<script lang="ts" setup>
import type { PropType} from 'vue';
import { computed, onMounted, ref } from 'vue';
import type { ICellRendererParams } from 'ag-grid-community';

/**********
 * Init
 **********/

const height = 20;
const progress = ref(0);

const props = defineProps({
    params: {
        type: Object as PropType<ICellRendererParams>,
        required: true
    }
});

onMounted(() => {
    // get the params ag-grid has injected.
    if (props.params?.data == null) return;

    // Set progress
    progress.value = (props.params.data.NoOfDiscussionsDone / props.params.data.NoOfDiscussions) * 100;
});

// Get progress text in percent
const progressText = computed(() => `${progress.value.toFixed(0)}%`);
</script>

<template>
    <div class="flex-container align-middle">
        <div class="flex-child-auto sy-progress-bar" :style="`height: ${height}px;`">
            <div class="sy-progress-bar active" :style="`width: ${progress}%; height: ${height}px;`"></div>
        </div>
        <div class="margin-left-5">
            {{ progressText }}
        </div>
    </div>
</template>

<style scoped lang="scss">
.sy-progress-bar {
    background-color: var(--sy-gray-200);
    border-radius: var(--sy-border-radius);

    &.active {
        background-color: #19A248;
    }
}
</style>
